var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/moon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/moon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "moon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.01589 8.19984C2.22653 11.1174 4.78346 13.4912 7.84359 13.6215C10.0026 13.7121 11.9335 12.7377 13.092 11.2024C13.5718 10.5736 13.3144 10.1543 12.5128 10.296C12.1207 10.364 11.717 10.3923 11.2957 10.3753C8.43455 10.262 6.09411 7.94491 6.08241 5.20861C6.07656 4.47213 6.23454 3.77531 6.52124 3.14081C6.8372 2.43832 6.45688 2.10407 5.72549 2.40433C3.40845 3.35042 1.82281 5.61084 2.01589 8.19984Z",
    stroke: "#707170",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.b7a7d802.svg";
export { ForwardRef as ReactComponent };